import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface DeleteCaseFilesRequest {
  caseId: string;
}

export const useDeleteCaseFiles = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<Response, Error, DeleteCaseFilesRequest, unknown>({
    mutationFn: async ({ caseId }: DeleteCaseFilesRequest) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.DELETE });
      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/all-files`, fetchConfig);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Files] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.UploadPagesEstimate] });
    },
  });
};
